import RecommendationAPI from '@personalization/scripts/apis/recommendation-api';
import React, {useEffect, useRef, useState} from 'react';
import SoldOutRecommendationContent from './SoldOutRecommendationsContent.jsx';
import {SliderTypes} from "../slider-types.js";
import SliderLandmarkHelper from "@core/scripts/components/tracking/landmarks/slider-landmark-helper.js";
import {Typography} from "bonprix-design-system";
import {contentElement} from "@product/helper/content-element/content-elements.ts";

export default function SoldOutRecommendation({ dataUrl, paramString, className, children }) {
    const [recoData, setRecoData] = useState(null);
    const [error, setError] = useState(false);
    const loadedDataForParamStrings = useRef({});
    const activeItemNumber = useRef(null);
    const inViewRef = useRef(null);

    const onRecommendationsFetched = (data) => {
        if (data?.recommendationProducts) {
            loadedDataForParamStrings.current[paramString] = data;
            activeItemNumber.current = new URLSearchParams(paramString).get('itemNumber');
        }
        setRecoData(data);
    };

    const onFetchingRecommendationsFailed = (error) => {
        setError(true);
    };

    const loadContentAndFillModel = () => {
        setError(false);
        const dataForParamString = loadedDataForParamStrings.current[paramString];
        const paramStringItemNumber = new URLSearchParams(paramString).get('itemNumber');

        if (paramStringItemNumber !== activeItemNumber.current) {
            if (dataForParamString) {
                onRecommendationsFetched(dataForParamString);
            } else {
                RecommendationAPI.get(dataUrl, paramString, 'Fetching Product Recommendations failed')
                    .then(onRecommendationsFetched)
                    .catch(onFetchingRecommendationsFailed);
            }
        }
    };

    const onSoldOutRecommendationVisible = () => {
        const landmarkData = recoData?.landmarkData;
        const recommendationProducts = recoData?.recommendationProducts;
        // building the event object manually here since there is no event object in this context
        SliderLandmarkHelper.createAndSendSliderVisibilityLandmark(SliderTypes.SOLD_OUT,
                {items: recommendationProducts, displayedItemCount: recommendationProducts?.length}, landmarkData, false);
    };

    useEffect(() => {
        loadContentAndFillModel();
    }, [paramString]);

    // TODO maybe use tanstack useQuery here to handle error, success and loading states

    if(error) return <Typography variant="body1">{contentElement('pdp__recommendations_no-alternatives_text')}</Typography>

    if (!recoData) return <div ref={inViewRef} />;

    onSoldOutRecommendationVisible();

    return (
        <SoldOutRecommendationContent recoData={recoData} className={className} children={children} />
    );
}